import { createHttpClient } from "./http";

export class RelatorioDistribuidorRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 300000 });
	}

	getHeaders() {
		return {
			Authorization: `Bearer ${localStorage.getItem("access_token")}`,
		};
	}

	getUnidadeId() {
		return localStorage.getItem("selected_unidade_id");
	}

	async fetchVisaoGeral(dataInicio, dataFim) {
		const unidadeId = this.getUnidadeId();
		if (!unidadeId) throw new Error("Unidade distribuidora não selecionada");

		const result = await this.axios.get("relatorio-distribuidor/visao-geral", {
			headers: this.getHeaders(),
			params: { unidadeDistribuidoraId: unidadeId, dataInicio, dataFim },
		});
		return result.data;
	}

	async fetchEntradas(dataInicio, dataFim, status, fornecedorId, search) {
		const unidadeId = this.getUnidadeId();
		if (!unidadeId) throw new Error("Unidade distribuidora não selecionada");

		const result = await this.axios.get("relatorio-distribuidor/entradas", {
			headers: this.getHeaders(),
			params: {
				unidadeDistribuidoraId: unidadeId,
				dataInicio,
				dataFim,
				status: status !== "todos" ? status : undefined,
				fornecedorId: fornecedorId !== "todos" ? fornecedorId : undefined,
				search: search || undefined,
			},
		});
		return result.data;
	}

	async fetchSaidas(dataInicio, dataFim, destinoId, search) {
		const unidadeId = this.getUnidadeId();
		if (!unidadeId) throw new Error("Unidade distribuidora não selecionada");

		const result = await this.axios.get("relatorio-distribuidor/saidas", {
			headers: this.getHeaders(),
			params: {
				unidadeDistribuidoraId: unidadeId,
				dataInicio,
				dataFim,
				destinoId: destinoId !== "todos" ? destinoId : undefined,
				search: search || undefined,
			},
		});
		return result.data;
	}

	async fetchBalanco(dataInicio, dataFim, produto, fornecedor, search) {
		const unidadeId = this.getUnidadeId();
		if (!unidadeId) throw new Error("Unidade distribuidora não selecionada");

		const result = await this.axios.get("relatorio-distribuidor/balanco", {
			headers: this.getHeaders(),
			params: {
				unidadeDistribuidoraId: unidadeId,
				dataInicio: dataInicio || undefined,
				dataFim: dataFim || undefined,
				produto: produto !== "todos" ? produto : undefined,
				fornecedor: fornecedor !== "todos" ? fornecedor : undefined,
				search: search || undefined,
			},
		});
		return result.data;
	}

	async fetchRastreabilidade(search) {
		const unidadeId = this.getUnidadeId();
		if (!unidadeId) throw new Error("Unidade distribuidora não selecionada");

		const result = await this.axios.get("relatorio-distribuidor/rastreabilidade", {
			headers: this.getHeaders(),
			params: {
				unidadeDistribuidoraId: unidadeId,
				search: search || undefined,
			},
		});
		return result.data;
	}
}
